import React, { useState } from 'react';
import tickImg from '../assets/images/double-tick.png';
import noteImg from '../assets/images/notes.png';
import plusImg from '../assets/images/plus.png';
import {
  useAddToDosMutation,
  useCompleteAllTaskMutation,
  useGetToDosQuery,
  useInCompleteAllTaskMutation,
} from '../features/api/apiSlice';
const Header = () => {
  const [textInput, setTextInput] = useState('');
  const handleInput = (e) => {
    e.preventDefault();
    setTextInput(e.target.value);
  };
  const resetForm = (e) => {
    setTextInput('');
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    addToDos({
      text: textInput,
      completed: true,
      color: 'red',
    });
    resetForm();
  };

  const [addToDos, { data: todos, isLoading, isError }] = useAddToDosMutation();
  const [completeAllTask, data] = useCompleteAllTaskMutation();
  const [inCompleteAllTask] = useInCompleteAllTaskMutation();
  const { data: allTodos } = useGetToDosQuery();

  const handleCompleteAll = () =>
    allTodos?.forEach((t) => {
      completeAllTask({
        id: t.id,
        data: {
          completed: true,
        },
      });
    });

  const handleInCompleteAll = () => {
    allTodos?.forEach((t) => {
      inCompleteAllTask({
        id: t.id,
        data: {
          completed: false,
        },
      });
    });
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
        action=""
      >
        <img src={noteImg} className="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          placeholder="Type your todo"
          className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
          value={textInput}
          onChange={handleInput}
        />
        <button
          type="submit"
          className={`appearance-none w-8 h-8 [url('${plusImg}')] bg-no-repeat bg-contain`}
        ></button>
      </form>
      <ul className="flex justify-between my-4 text-xs text-gray-500">
        <li
          onClick={handleCompleteAll}
          className="flex space-x-1 cursor-pointer"
        >
          <img className="w-4 h-4" src={tickImg} alt="Complete" />
          <span>Complete All Tasks</span>
        </li>
        <li onClick={handleInCompleteAll} className="cursor-pointer">
          Clear completed
        </li>
      </ul>
    </div>
  );
};

export default Header;
